import { render, staticRenderFns } from "./DetailBlog2.vue?vue&type=template&id=9c10acf2&"
import script from "./DetailBlog2.vue?vue&type=script&lang=js&"
export * from "./DetailBlog2.vue?vue&type=script&lang=js&"
import style0 from "./DetailBlog2.vue?vue&type=style&index=0&id=9c10acf2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c10acf2')) {
      api.createRecord('9c10acf2', component.options)
    } else {
      api.reload('9c10acf2', component.options)
    }
    module.hot.accept("./DetailBlog2.vue?vue&type=template&id=9c10acf2&", function () {
      api.rerender('9c10acf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/PageChild/DetailBlog2.vue"
export default component.exports